var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 224,
    viewBox: "0 0 248 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.886 216.664C122.815 219.467 121.948 222.525 120.096 223.061C118.244 223.598 116.478 222.842 115.549 220.039C114.62 217.236 115.345 215.798 117.198 215.261C119.05 214.725 120.957 213.861 121.886 216.664Z",
    fill: "#BAD2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M240.507 209.77C236.228 213.398 230.099 214.422 227.702 211.95C225.304 209.478 225.28 206.136 229.559 202.508C233.838 198.88 236.968 198.894 239.366 201.366C241.763 203.838 244.786 206.142 240.507 209.77Z",
    fill: "#BAD2FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7051 204.263C24.7722 209.294 14.4725 208.856 9.20296 203.423C3.93348 197.99 2.44778 191.859 8.38063 186.828C14.3135 181.798 19.8064 183.005 25.0759 188.438C30.3454 193.872 36.6379 199.233 30.7051 204.263Z",
    fill: "#BAD2FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8333 120.849C55.7624 123.652 54.8954 126.709 53.0432 127.246C51.1909 127.783 49.425 127.027 48.4959 124.224C47.5668 121.421 48.2926 119.983 50.1449 119.446C51.9971 118.909 53.9042 118.046 54.8333 120.849Z",
    fill: "#BAD2FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M217.808 73.9859C217.161 66.3374 224.036 58.7987 232.098 58.2021C240.16 57.6054 246.444 60.3156 247.092 67.9641C247.739 75.6126 243.223 79.0233 235.161 79.62C227.099 80.2166 218.456 81.6343 217.808 73.9859Z",
    fill: "#4585FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3572 59.0207C12.7243 60.6461 8.91113 58.6824 6.93448 56.8342C4.95783 54.986 2.45652 51.3464 5.3369 48.6532C8.21728 45.9601 12.0728 49.6872 14.0495 51.5354C16.0261 53.3836 15.9901 57.3953 14.3572 59.0207Z",
    fill: "#4585FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2443 26.7875C89.9654 30.4155 83.8365 31.4398 81.4391 28.9678C79.0416 26.4959 79.0174 23.1539 83.2962 19.5258C87.5751 15.8977 90.7056 15.9118 93.103 18.3837C95.5005 20.8557 98.5231 23.1594 94.2443 26.7875Z",
    fill: "#BAD2FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M170.061 2.92708C170.832 5.61852 168.909 8.73516 166.072 9.44589C163.236 10.1566 160.8 9.57672 160.029 6.88527C159.257 4.19383 160.629 2.69699 163.466 1.98626C166.303 1.27554 169.29 0.235638 170.061 2.92708Z",
    fill: "#D1E0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageBg);
export default __webpack_public_path__ + "static/media/ImageBG.f6ffe4bfe42f8298904c2b18b702cc79.svg";
export { ForwardRef as ReactComponent };